var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ForTheRecord {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.currentInputCode = '1';
        this.videoInputCodes = [];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (value.operation === 'mediaRecorderRecord') {
                    const match = yield this.socket.send(`#12StartRec`, /#\d+(.+)/i, tags);
                    if (match[1].toLowerCase() === 'recstarted') {
                        if (this.state.mediaRecorderState.values[key] !== 'recording') {
                            this.state.mediaRecorderStartTime.update(key, Date.now());
                        }
                        this.state.mediaRecorderState.update(key, 'recording');
                    }
                }
                else if (value.operation === 'mediaRecorderStop') {
                    const match = yield this.socket.send(`#11StopRec`, /#\d+(.+)/i, tags);
                    if (match[1].toLowerCase() === 'recstopped') {
                        this.state.mediaRecorderState.update(key, 'stopped');
                    }
                }
                return value;
            }),
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return Object.fromEntries(this.videoInputCodes.map(code => [
                    code,
                    ['mediaRecorderRecord', 'mediaRecorderStop'],
                ]));
            }),
        };
        this.mediaRecorderStartTime = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                return (_a = this.state.mediaRecorderStartTime.values[key]) !== null && _a !== void 0 ? _a : 0;
            }),
            asyncHandlers: {
                regExp: /#\d+RecTime=(\d{2})(\d{2})(\d{2})/i,
                callback: (match) => {
                    const hh = parseInt(match[1], 10);
                    const mm = parseInt(match[2], 10);
                    const ss = parseInt(match[3], 10);
                    const elapsedTime = ((hh * 60 + mm) * 60 + ss) * 1000;
                    // Since we can't query the device to determine whether it is recording, if we
                    // receive a recording time update update that is non-zero, then set the state to
                    // recording.
                    if (elapsedTime > 0 &&
                        this.state.mediaRecorderState.values[this.currentInputCode] !== 'recording') {
                        this.state.mediaRecorderState.update(this.currentInputCode, 'recording');
                    }
                    this.state.mediaRecorderStartTime.update(this.currentInputCode, Date.now() - elapsedTime);
                },
            },
        };
        this.mediaRecorderState = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _b;
                // TODO: We need a way to query the recorder state. For example, if the driver connects
                // while the software is in the middle of recording, how will we know it is recording?
                return (_b = this.state.mediaRecorderState.values[key]) !== null && _b !== void 0 ? _b : 'stopped';
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.currentInputCode;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                if (!this.videoInputCodes.includes(code)) {
                    this.log.error(`invalid code: ${code}`);
                    return this.state.videoInput.value;
                }
                this.currentInputCode = code;
                return code;
            }),
        };
    }
    // polling
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.videoInputCodes = Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {}).map(v => v.code);
            if (!this.videoInputCodes.includes(this.currentInputCode)) {
                this.currentInputCode = (_b = this.videoInputCodes.sort()[0]) !== null && _b !== void 0 ? _b : '1';
            }
        });
    }
}
// static properties
ForTheRecord.driverType = 'socketDriver';
ForTheRecord.key = '-N84JcLcVUAlnT3u9UZB';
ForTheRecord.socketOptions = (config) => {
    var _a;
    return [
        {
            commandExtractor: {
                terminators: ['?'],
            },
            sendTerminator: '?',
            idleTimeoutMs: 0,
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 1025,
        },
    ];
};
